export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const CREATE_ACCOUNT_ERROR = 'CREATE_ACCOUNT_ERROR';
export const CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS';
export const CREATE_ACCOUNT_PAGE_LOADED_SUCCESS = 'CREATE_ACCOUNT_PAGE_LOADED_SUCCESS';
export const ACCOUNT_CREATION_ERROR = 'ACCOUNT_CREATION_ERROR';
export const GROUPA_PAGE_LOADED_SUCCESS = 'GROUPA_PAGE_LOADED_SUCCESS';
export const ACCOUNT_REGISTERED = 'ACCOUNT_REGISTERED';
export const SIGNOUT_PAGE_LOAD_ACTION = 'SIGNOUT_PAGE_LOAD_ACTION';
